import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";

import Page from "@/components/Page";
import Loading from "@/components/Loading";
import Breadcrumbs from "@/components/Breadcrumbs";
import MainActions from "@/components/MainActions";
import CardsList from "@/components/CardsList";

import {RosterAPI} from "@/api/roster";
import {visibleRosters} from "@/utils/functions";

import AddIcon from "@mui/icons-material/Add";

import {ERROR_OPERATION, getInternalClubId} from "@/utils/constants";

import "./index.scss";

function ScoutingRostersPage(props) {
	const {handleNotification} = props;

	const navigate = useNavigate();
	const seasonId = useSelector((state) => state?.season?.id);

	const [loading, setLoading] = useState(false);
	const [rosters, setRosters] = useState([]);

	const getRosters = async () => {
		setLoading(true);
		try {
			const response = await RosterAPI.list({prospect: true, seasonId, clubId: getInternalClubId()});
			setRosters(visibleRosters((response || []).filter((r) => r.prospect)));
		} catch (error) {
			handleNotification(ERROR_OPERATION, "error");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getRosters();
	}, []);

	const listConfiguration = {
		data: rosters,
		onClick: (roster) => navigate("/development/rosters/" + roster.id),
	};

	const mainActions = [
		{
			icon: <AddIcon />,
			title: "Aggiungi giocatore",
			onClick: () => navigate("/development/rosters/new"),
		},
	];

	return (
		<Page>
			<Loading visible={loading} />
			<Breadcrumbs
				current="Roster sviluppo"
				actions={<MainActions actions={mainActions} />}
			/>
			{/* <div className="d-flex flex-column gap-2">
				{rosters.length ? (
					rosters
						.sort((a, b) => {
							const categoryA = a.players[0]?.playersCategory?.name || "";
							const categoryB = b.players[0]?.playersCategory?.name || "";

							if (categoryA > categoryB) return -1;
							if (categoryA < categoryB) return 1;
							return 0;
						})
						.map((r, k) => {
							return (
								<div className="rosters-container d-flex flex-column" key={k}>
									<div className="d-flex align-items-center justify-content-between">
										<div className="roster-title">
											{r.name +
												(r.players?.length
													? " - " + r.players[0]?.playersCategory?.name
													: "")}
										</div>
										<div className="d-flex align-items-center gap-3">
											<div
												className="d-flex align-items-center clickable"
												onClick={() => {
													setInitialData(Object.assign({}, r));
													setOpenModal(true);
												}}
											>
												<EditIcon className="roster-icon" />
											</div>
											<div
												className="d-flex align-items-center clickable"
												onClick={() => {
													deleteRoster(r.id);
												}}
											>
												<DeleteIcon className="roster-icon" />
											</div>
										</div>
									</div>
									<CardsList
										type="roster_player"
										listConfiguration={getPlayersListConfiguration(r)}
									/>
								</div>
							);
						})
				) : (
					<EmptyData />
				)}
			</div> */}
			<CardsList
				type="manager_football_team"
				breadcrumbs
				listConfiguration={listConfiguration}
			/>
		</Page>
	);
}

export default ScoutingRostersPage;
